// extracted by mini-css-extract-plugin
export default {"ingredient_line":"IngredientReferenceLine_ingredient_line__VBhG4","title":"IngredientReferenceLine_title__M4JCX","quantity":"IngredientReferenceLine_quantity__ATlPu"};